var _path, _path2, _g, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19257",
    "data-name": "Group 19257",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.667,
    height: 66.667,
    viewBox: "0 0 66.667 66.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21520",
    "data-name": "Path 21520",
    d: "M0,0H66.667V66.667",
    fill: "rgba(255,255,255,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21521",
    "data-name": "Path 21521",
    d: "M0,0H66.667V66.667",
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19300",
    "data-name": "Group 19300",
    transform: "translate(9.176 12.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21522",
    "data-name": "Path 21522",
    d: "M26.121,0C15.491,0-1.832,12.2.137,24.8s14.3,18.9,25.984,18.9,22.7-6.955,22.7-19.029S36.882,0,26.121,0Z",
    transform: "translate(0.018)",
    fill: "#f3f8ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19299",
    "data-name": "Group 19299",
    transform: "translate(8.7 0.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21523",
    "data-name": "Path 21523",
    d: "M4.206,9.7H26.253a3.809,3.809,0,0,1,3.806,3.806V32.8A3.809,3.809,0,0,1,26.253,36.6H4.206A3.809,3.809,0,0,1,.4,32.8V13.375A3.873,3.873,0,0,1,4.206,9.7Z",
    transform: "translate(0.183 3.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21524",
    "data-name": "Path 21524",
    d: "M2.437,28H28.29a1.794,1.794,0,0,1,1.837,1.837v.656H.6v-.656A1.976,1.976,0,0,1,2.437,28Z",
    transform: "translate(0.246 8.746)",
    fill: "#ff7e94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21525",
    "data-name": "Path 21525",
    d: "M22.862,27.8c0,.131,0,.262-.131.262v.394a.837.837,0,0,0,0-.787h.131c0-.131-.131-.394-.262-.262C22.862,27.54,22.731,27.54,22.862,27.8Z",
    transform: "translate(7.117 8.55)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21526",
    "data-name": "Path 21526",
    d: "M22.7,25.9v0Z",
    transform: "translate(7.148 8.09)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21527",
    "data-name": "Path 21527",
    d: "M20.8,29.6Z",
    transform: "translate(6.555 9.245)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21528",
    "data-name": "Path 21528",
    d: "M14.1,29.7Z",
    transform: "translate(4.462 9.277)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21529",
    "data-name": "Path 21529",
    d: "M22.7,25.8Z",
    transform: "translate(7.148 8.058)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21530",
    "data-name": "Path 21530",
    d: "M1,27.7Z",
    transform: "translate(0.371 8.652)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21531",
    "data-name": "Path 21531",
    d: "M22.823,19h0C22.692,19.131,22.823,19.131,22.823,19Z",
    transform: "translate(7.156 5.935)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21532",
    "data-name": "Path 21532",
    d: "M22.7,20.6v0Z",
    transform: "translate(7.148 6.434)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21533",
    "data-name": "Path 21533",
    d: "M22.7,21.8Z",
    transform: "translate(7.148 6.809)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21534",
    "data-name": "Path 21534",
    d: "M17.336,8Z",
    transform: "translate(5.426 2.499)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21535",
    "data-name": "Path 21535",
    d: "M22.7,27Z",
    transform: "translate(7.148 8.433)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21536",
    "data-name": "Path 21536",
    d: "M22.7,27.1v0Z",
    transform: "translate(7.148 8.464)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21537",
    "data-name": "Path 21537",
    d: "M22.7,24.9v.525h0Z",
    transform: "translate(7.148 7.777)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21538",
    "data-name": "Path 21538",
    d: "M22.7,10.9v.262l.131.131Z",
    transform: "translate(7.148 3.405)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21539",
    "data-name": "Path 21539",
    d: "M8.614,1.8h0C8.614,1.931,8.483,1.931,8.614,1.8Z",
    transform: "translate(2.731 0.562)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21540",
    "data-name": "Path 21540",
    d: "M15.6,7.1Z",
    transform: "translate(4.931 2.218)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21541",
    "data-name": "Path 21541",
    d: "M12.9.6Z",
    transform: "translate(4.088 0.187)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21542",
    "data-name": "Path 21542",
    d: "M13,7.223Z",
    transform: "translate(4.119 2.225)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21543",
    "data-name": "Path 21543",
    d: "M15.1,7.1Z",
    transform: "translate(4.775 2.218)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21544",
    "data-name": "Path 21544",
    d: "M17.9,7.1Z",
    transform: "translate(5.649 2.218)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21545",
    "data-name": "Path 21545",
    d: "M15.6,1.1v.131S15.994,1.625,15.6,1.1Z",
    transform: "translate(4.931 0.344)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21546",
    "data-name": "Path 21546",
    d: "M9.625,30.6h0Z",
    transform: "translate(2.901 9.558)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21547",
    "data-name": "Path 21547",
    d: "M7.962,30.6h0Z",
    transform: "translate(2.463 9.558)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21548",
    "data-name": "Path 21548",
    d: "M23.1,29.4Z",
    transform: "translate(7.273 9.183)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21549",
    "data-name": "Path 21549",
    d: "M16.9,3.7Z",
    transform: "translate(5.337 1.156)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21550",
    "data-name": "Path 21550",
    d: "M8.807,11.942H8.15a.983.983,0,0,0-.656.131,4.921,4.921,0,0,0-1.444-.131c-.262,0-.394.131-.656.131v-.131l-.525.131-.262-.131h0a3.633,3.633,0,0,1-1.181-.131H2.9a1.183,1.183,0,0,0-.656.131c.131,0,.131-.131.262-.131H2.245l-.394.131c.131,0,0,0,0,.131A2.316,2.316,0,0,0,.67,13.123v-.131A2.332,2.332,0,0,0,.145,14.3v1.312c0-.262.131-.262.131,0l-.131.131c0,.131,0-.262.131.131,0,.262-.131.262-.131,0v.394a.129.129,0,0,0-.131-.131,2.144,2.144,0,0,0,0,.919h0v1.969c.131,0,.131.262.131.525,0,.525-.131,1.05-.131,1.706,0,.394.131.131.131.262-.131,0-.131.656-.131.394a9.3,9.3,0,0,0,.131,1.837c0-.131,0-.262.131-.131,0,.131,0,.394-.131.394h0c.131,1.05-.262,2.493,0,3.281h0l.131.919c0,.394,0-.262-.131,0,.131.919,0,1.444.131,2.231-.262.656,0,2.1-.131,2.887h0v.394s0-.262.131-.131v4.068A2.522,2.522,0,0,0,.8,39.239c.131.131.262.394.525.394l.787.394H1.851a3.832,3.832,0,0,0,1.181.262H7.363c.262,0,0,0,.131.131.262,0,.787-.131.919,0H8.282c.131,0,.919,0,.787-.131h1.444c.262-.131.919,0,1.05-.131,0,.131.919.131,1.312,0-.131,0,.262,0,.131.131.394,0,.787,0,.656-.131.656.131,1.444-.131,1.837.131a28.544,28.544,0,0,1,3.281-.131c0,.131-1.181,0-1.05.131.919,0,1.575-.131,2.493-.131.262,0-.131,0-.262.131h2.887c-.262-.131.656-.131.656-.262-.262.131.919,0,.394.262.131,0,.262,0,.262-.131.131,0,.262,0,0,.131.656,0,.394-.131.919-.131a.129.129,0,0,0-.131.131A2.89,2.89,0,0,1,26,40.158h-.131c.787,0,1.444-.131,2.231-.131-.262.131.262,0,.394.131a.789.789,0,0,0,.525-.131h-.262l1.181-.394c-.131.131-.131.131-.262.131a1.31,1.31,0,0,0,.656-.525c-.131.131-.262.131-.394.262.262-.262-.131,0,.394-.394l.394-.394.262-.656c0-.131.131.131.131,0V37.4c0-.262,0-.394-.131-.525,0,.131.131.131.131,0l-.525-.131c0-.131,0-.262.131-.131,0-.525-.131.131-.131-.525V34.383c.131-.131,0,.525.131.262,0-.787-.131-1.706-.131-2.625v.131c-.131-.131.131-.656,0-1.05a.129.129,0,0,0,.131.131,11.333,11.333,0,0,0-.131-1.969v-1.05c0-.131,0-.262-.131-.131.262-1.05-.131-2.1.131-3.018V24.41c-.131,0,0,.131-.131.262,0-.131-.131-.394-.131-.525,0,.394.131,0,.131-.131h-.131c.131-.394-.131-.131,0-.656h0V22.7c.131-.131,0,.262.131.262a2.233,2.233,0,0,1-.131-.919v.525c0-.262.131-.394.131-.656h0v-.394c-.262-.394,0-.919-.131-1.444.131.525.131.131.131.131,0-.131,0-.394.131-.262-.131-.262,0-.394,0-.787,0,0,0-.262.131-.262,0-.394,0,.131-.131,0-.131-.525.131-1.312,0-1.969a3.883,3.883,0,0,0-.262-1.312v-.131c0-.131.131.262.131.262v-.919l.131-.131c0-.262-.131-.131-.131-.525.131.131.131.131.131.262-.131-.262-.262-.656-.394-.919,0-.131.131.131.262.262a1.183,1.183,0,0,0-.787-.787l.131.131c-.131-.131,0-.131.131,0,.262.262.262.394.262.394v-.262c0,.131.131.262.262.525a1.865,1.865,0,0,1,.262.787l-.262-.131a2.439,2.439,0,0,0-2.493-2.1h0V12.2H28.1a.129.129,0,0,0,.131-.131h-.262a.767.767,0,0,0-.525-.131l-.525.131h-.394c-.131,0-.131-.131-.262-.131l-.525.131s.262-.131-.131-.131c-.262,0,.262.131-.131.131-.262,0-.131-.131-.525,0l.131-.131a1.664,1.664,0,0,0-.787.131c-.262-.131-.919,0-.919-.131a5.684,5.684,0,0,0-.656.131c.262-.131,0-.131-.262-.131h-.131v-.131h0Zm20.866,1.706h0a.682.682,0,0,1,.262.525H29.8a.482.482,0,0,1,.131.394.789.789,0,0,0,.131.525c0-.131-.131-.131-.131,0l.131.131c0,.131,0,.131-.131.131,0,.525.131-.131.131.394v1.444c-.131.131,0-.394-.131-.262,0,.787.131,1.575.131,2.231v-.131c.131.131-.131.525,0,.919a.129.129,0,0,0-.131-.131,7.483,7.483,0,0,0,.131,1.706v.919c0,.131,0,.262.131.131-.262.919.131,1.837-.131,2.625v.525c.131,0,0-.131.131-.262,0,.131.131.262.131.525,0-.262-.131,0-.131.131h.131c-.131.394.131,0,0,.525h0v.525c-.131.131,0-.262-.131-.262,0,.262.131.525.131.787V27.3c0,.131-.131.394-.131.525h0v.394c.262.394,0,.787.131,1.181-.131-.525-.131-.131-.131-.131,0,.131,0,.262-.131.262.131.262,0,.394,0,.656,0,0,0,.262-.131.131,0,.262,0-.131.131,0,.131.525-.131,1.05,0,1.706a2.472,2.472,0,0,0,.262,1.05V33.2c0,.131-.131-.131-.131-.131v.787l-.131.131c0,.262.131.131,0,.394,0-.131-.131-.131-.131-.262,0,.262.131.525.131.787,0,.131-.131-.131-.131-.262a2.233,2.233,0,0,0,.131.919v-.131c0,.131-.131,0-.131,0v-.262c.131-.131,0-.787,0-1.181l.131.131v2.887h-.131v-.131l-.131-.131v.262h0a1.624,1.624,0,0,0-.262.394V37.8a.129.129,0,0,0-.131.131c0-.131.131-.131.131-.262a.482.482,0,0,0-.131.394.129.129,0,0,0-.131.131c0,.131-.131.262-.131.394-.131,0,0-.131-.131,0s.262,0,0,.131c-.262,0-.131,0-.394.131l.131-.131c-.131.131-.525.131-.525.131-.262-.131-.787,0-.787-.131-.262,0-.394.131-.656.131.394-.131-.787,0-.656-.131a6.389,6.389,0,0,1-1.575.131h.131a.789.789,0,0,1-.525-.131c0,.131-.525.131-.787.262-.394-.131.262-.131.131-.262,0,.131-.656.131-.525.131-.262,0-.262,0-.394-.131,0,.131-.262,0-.525.131-.394-.131-.131-.131-.525-.131-.262,0,.131-.131.131-.131-.394,0-.262.131-.262.131-.525,0-.262-.131-.394-.131-.262,0-.525.131-.787.131h0c-.394.131-1.05,0-1.444.131h0s.131.131,0,.131-.394.131-.394,0h-.131c-.131-.131.262,0,.262-.131-.394,0-.787.131-1.181.131,0-.131.656,0,.262-.131h.525c-.394-.131.262,0,0-.131H16.812c-.131,0,0,.131-.131.131-.919.131-.656-.262-1.312-.131a1.183,1.183,0,0,1-.656.131l.131-.131c-.656,0-.394.131-.919.131h.394c-.394-.131-.262,0-.656,0v-.131c-.656,0-1.312.131-2.1.131,0,0,.131,0,0-.131a19.382,19.382,0,0,1-2.756-.131l-.394.131h0c-.394,0,0,0-.131.131-.131,0-.262,0-.131-.131a7.136,7.136,0,0,1-2.362,0h.131c-.525,0-.525.131-1.05.131H2.639a1,1,0,0,1-.525-.262c-.131,0-.262-.131-.394-.262s-.262,0-.394,0V37.139c0-.262-.131-.262-.131-.525h.131l-.131-.394.131-.131v-.262c0,.131,0,.262-.131.131a2.233,2.233,0,0,1,.131-.919v-.787a.406.406,0,0,0,.131.262c-.131-.525.131-.131,0-.525H1.326V30.971c0,.262-.131.262-.131,0l.131-.262c0-.131,0,.262-.131,0,0-.262.131-.131.131,0v-.394l.131.131c0-.131.131-.525,0-.787h0V27.953c-.131,0-.131-.262-.131-.394,0-.394.131-.919.131-1.444,0-.394-.131-.131-.131-.262.131,0,.131-.525.131-.262a6.935,6.935,0,0,0-.131-1.575c0,.131,0,.131-.131.131,0-.131,0-.394.131-.262h0c-.131-.919.262-2.1,0-2.887h0l-.131-.787c0-.394,0,.262.131,0-.131-.787,0-1.312-.131-1.969a15.882,15.882,0,0,0,.131-2.493h0v-.394a.129.129,0,0,1-.131.131v-1.05c.131-.262.262-.656.525-.787a1.569,1.569,0,0,1,1.05-.525H4.082c.656,0,.394-.262,1.181-.131L5,13.123c1.312-.131,2.625,0,3.806-.131h.919c.131,0,0,0,.131.131.262,0,.656-.131.787,0h-.131c.131,0,.787,0,.656-.131h1.312c.262-.131.787,0,.919-.131,0,.131.787.131,1.05,0-.131,0,.262,0,.131.131.394,0,.656,0,.525-.131.656.131,1.181-.131,1.575.131a21.3,21.3,0,0,1,2.756-.131c0,.131-1.05,0-.919.131a12.732,12.732,0,0,1,2.231-.131c.262,0-.131,0-.262.131h2.625c-.262-.131.656-.131.656-.262-.262.131.787,0,.394.262.131,0,.262,0,.262-.131.131,0,.131,0,0,.131.525,0,.394-.131.787-.131a.129.129,0,0,0-.131.131A2.233,2.233,0,0,1,26,12.861h-.131c.656,0,1.181-.131,1.969-.131-.262.131.262,0,.262.131h.262a2.233,2.233,0,0,1,.919.131h-.262a1,1,0,0,1,.525.262l-.262-.262c.262.131,0-.131.394.131C29.279,13.255,29.673,13.517,29.673,13.648ZM10.644,39.108h0Zm.919,0Zm18.5-7.48c0-.131,0-.131-.131-.262l.131-.131Zm0,2.362-.131-.394a.129.129,0,0,1,.131-.131Zm0-10.892a.406.406,0,0,0-.131-.262h.131ZM13.269.787c0,.131-.131.131,0,0-.131.131-.131,0,0,0C13.137.919,13.137.787,13.269.787Zm-.262.131ZM12.875,0l-.262.131h0Zm-.787.394h0a1.888,1.888,0,0,0-.394.262c.131-.131.262-.131.394-.262Zm18.5,24.672h0L30.46,24.8C30.591,24.672,30.591,24.8,30.591,25.066Zm-.131-9.843v-.394c.131.131.131.131,0,.394Z",
    transform: "translate(0.044)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21551",
    "data-name": "Path 21551",
    d: "M1.9,7.223h.131C1.9,7.092,1.9,7.092,1.9,7.223Z",
    transform: "translate(0.652 2.225)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21552",
    "data-name": "Path 21552",
    d: "M4,7.1Z",
    transform: "translate(1.308 2.218)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21553",
    "data-name": "Path 21553",
    d: "M23.4,17.223Z",
    transform: "translate(7.367 5.349)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21554",
    "data-name": "Path 21554",
    d: "M23.4,15.494v0Z",
    transform: "translate(7.367 4.716)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21555",
    "data-name": "Path 21555",
    d: "M23.4,14Z",
    transform: "translate(7.367 4.373)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21556",
    "data-name": "Path 21556",
    d: "M16.814,30.6Z",
    transform: "translate(5.292 9.558)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21557",
    "data-name": "Path 21557",
    d: "M23.131,29.4c0,.131-.131.131-.131.262A.406.406,0,0,0,23.131,29.4Z",
    transform: "translate(7.242 9.183)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21558",
    "data-name": "Path 21558",
    d: "M9.6,30.6Z",
    transform: "translate(3.057 9.558)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21559",
    "data-name": "Path 21559",
    d: "M23.062,29.6l-.262.262C22.931,29.862,22.931,29.731,23.062,29.6Z",
    transform: "translate(7.18 9.245)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21560",
    "data-name": "Path 21560",
    d: "M23.431,26.594v-.262L23.3,26.2Z",
    transform: "translate(7.336 8.183)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21561",
    "data-name": "Path 21561",
    d: "M12.031,21.731h0s.131-.131,0-.131v.131c-.131.131-.131,0,0,0-.131,0-.131-.131-.131,0S11.9,21.862,12.031,21.731Z",
    transform: "translate(3.775 6.747)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21562",
    "data-name": "Path 21562",
    d: "M12.3,21.6Z",
    transform: "translate(3.9 6.747)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21563",
    "data-name": "Path 21563",
    d: "M10,21.023Z",
    transform: "translate(3.182 6.536)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21564",
    "data-name": "Path 21564",
    d: "M12.3,21.6Z",
    transform: "translate(3.9 6.747)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21565",
    "data-name": "Path 21565",
    d: "M13.5,16.923Z",
    transform: "translate(4.275 5.255)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21566",
    "data-name": "Path 21566",
    d: "M12.1,21.7Z",
    transform: "translate(3.838 6.778)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21567",
    "data-name": "Path 21567",
    d: "M12.1,21.7Z",
    transform: "translate(3.838 6.778)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21568",
    "data-name": "Path 21568",
    d: "M9.2,18.3Z",
    transform: "translate(2.932 5.716)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21569",
    "data-name": "Path 21569",
    d: "M13.1,21.3Z",
    transform: "translate(4.15 6.653)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21570",
    "data-name": "Path 21570",
    d: "M14.4,18.114Z",
    transform: "translate(4.556 5.64)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21571",
    "data-name": "Path 21571",
    d: "M14.6,19.2Z",
    transform: "translate(4.619 5.997)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21572",
    "data-name": "Path 21572",
    d: "M13.7,17.1Z",
    transform: "translate(4.337 5.341)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21573",
    "data-name": "Path 21573",
    d: "M12.1,21.6Z",
    transform: "translate(3.838 6.747)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21574",
    "data-name": "Path 21574",
    d: "M12,21.6Z",
    transform: "translate(3.806 6.747)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21575",
    "data-name": "Path 21575",
    d: "M12.514,21.5h0C12.383,21.5,12.514,21.631,12.514,21.5Z",
    transform: "translate(3.949 6.715)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21576",
    "data-name": "Path 21576",
    d: "M14.5,19.7Z",
    transform: "translate(4.587 6.153)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21577",
    "data-name": "Path 21577",
    d: "M12.031,15.531h0l.131-.131c-.131,0-.131,0-.131.131h0c-.131,0-.131-.131-.131,0Z",
    transform: "translate(3.775 4.81)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21578",
    "data-name": "Path 21578",
    d: "M12.4,15.4Z",
    transform: "translate(3.931 4.81)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21579",
    "data-name": "Path 21579",
    d: "M9.5,16.114Z",
    transform: "translate(3.026 5.015)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21580",
    "data-name": "Path 21580",
    d: "M12.523,15.4Z",
    transform: "translate(3.939 4.81)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21581",
    "data-name": "Path 21581",
    d: "M14.223,21.6Z",
    transform: "translate(4.47 6.747)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21582",
    "data-name": "Path 21582",
    d: "M8.3,19.7Z",
    transform: "translate(2.651 6.153)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21583",
    "data-name": "Path 21583",
    d: "M13.4,15.8Z",
    transform: "translate(4.244 4.935)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21584",
    "data-name": "Path 21584",
    d: "M15.2,19.9Z",
    transform: "translate(4.806 6.216)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21585",
    "data-name": "Path 21585",
    d: "M15.2,18.5Z",
    transform: "translate(4.806 5.778)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21586",
    "data-name": "Path 21586",
    d: "M14.4,21.4Z",
    transform: "translate(4.556 6.684)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21587",
    "data-name": "Path 21587",
    d: "M12.2,15.4Z",
    transform: "translate(3.869 4.81)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21588",
    "data-name": "Path 21588",
    d: "M12.1,15.4Z",
    transform: "translate(3.838 4.81)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21589",
    "data-name": "Path 21589",
    d: "M12.731,15.514H12.6C12.6,15.383,12.731,15.514,12.731,15.514Z",
    transform: "translate(3.994 4.827)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21590",
    "data-name": "Path 21590",
    d: "M15.1,17.8Z",
    transform: "translate(4.775 5.56)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21591",
    "data-name": "Path 21591",
    d: "M22.692,12.356c-.131.262,0-.919-.131-1.444v.131a1.665,1.665,0,0,1,.131-.787c-.131,0-.131-.656-.262-1.05.131-.525.131.262.394.131-.131,0-.131-.919-.262-.656.131-.394,0-.262.131-.525-.262,0,0-.394-.262-.656,0-.525.131-.131,0-.787,0-.262.131.131.131.262-.131-.656-.262-.262-.262-.394-.262-.787,0-.394,0-.656a12.1,12.1,0,0,1-.656-1.05h0A8.425,8.425,0,0,0,20.33,3.17V3.039c0,.131,0,.131-.131.131-.262-.262-.394-.262-.394-.525,0,.131.131.131.262.131-.131,0-.131-.131-.262-.131-.131-.262.394.262.394.262a10.016,10.016,0,0,0-1.444-1.05c0-.131.919.656.525.131l.525.525c-.262-.525.394.262.131-.131-.262-.262-.525-.394-.787-.656A7.528,7.528,0,0,1,18.23,1.2c-.262,0,0,.131-.262.131a2.638,2.638,0,0,1-1.05-.525A1.107,1.107,0,0,0,16,.545a1.438,1.438,0,0,1-1.05,0l.262-.131H13.637c.131-.131.787,0,.656,0-.656-.131-.525.131-.919.131L13.243.414a9.558,9.558,0,0,0-3.15.919s.131-.131,0-.131A11.29,11.29,0,0,0,6.681,3.826c-.131-.131-.262,0-.262.131-.131.131-.131.262-.131.131-.262.394,0,0,0,.262-.131.262-.262.262-.262.131l-.262.656a8.363,8.363,0,0,1-.262.919,17.118,17.118,0,0,1-.394,1.706V7.632c-.131.656.262.787.131,1.444v3.412l1.312-1.05c-.262-.262,0-.525-.131-.787s-.262-.394-.262-.525h0l.131.131V9.863h.131c0-.131-.131,0-.131-.131a.129.129,0,0,1,.131.131.767.767,0,0,0-.131-.525.129.129,0,0,1,.131.131c0-.131,0-.394-.131-.394h0c.131.131,0,.131,0,.131V9.075c-.262.131,0,.394,0,.656H6.156V8.419h.262V8.288h0c.131,0,.131-.131.262-.131L6.55,8.025h.131v.131c.131-.131,0-.131,0-.262a.129.129,0,0,0,.131-.131L6.55,7.632c.131,0,.131.131.131,0-.131-.131-.131,0-.262-.131.131-.131.131,0,.131-.131h.131c0-.131,0-.262-.131-.262.131-.131,0-.262.262-.262,0-.131-.131-.131-.131-.262.262.262.131-.262.394-.131-.131-.131,0-.394,0-.656h0a.129.129,0,0,1,.131-.131V5.27c.262,0,.131.131.262.131-.131,0,0-.262-.131-.262H7.6c-.262-.131,0,0-.131-.131.131-.131.131,0,.262-.131a.129.129,0,0,1,.131.131c0-.131-.131-.131-.262-.262.131-.131.131,0,.262,0V4.351h0c0-.131.262-.262.262-.525h0a.131.131,0,0,1,0-.262v0c.131,0,0,.131,0,.131.131-.131.131-.394.262-.394.131.131-.131.262,0,.262v.131c.262,0,0,.131.262.131.131-.131.131-.262.262-.394,0-.131-.131,0-.131-.131.131-.262.394,0,.525-.262,0-.131-.131-.262.131-.262v.131c.262-.131,0-.262.262-.262a.129.129,0,0,1-.131.131c.262,0,0-.131.131-.262l.131.131c.262-.131.525-.394.787-.525v.131a2.472,2.472,0,0,1,1.05-.262l.131-.131h0c.131,0,0-.131,0-.131.131,0,.131,0,.131.131a1.107,1.107,0,0,1,.919-.262h0c.262,0,.262-.262.394-.131H13.9c.262,0,.394,0,.525.131.131-.131.394.131.525-.131a.682.682,0,0,0,.525.262c.131,0,.131-.131.262-.131v.131l.131-.131v.131H16s-.131-.131,0-.131.394.262.394.262h.262c.262,0,0,.131.262.131V1.857c.131.131.262.262.394.262H17.18l.787.394V2.382H18.1v.131c.131,0,0-.131.131-.131.131.131,0,.131-.131.131h0c.131,0,.131.262.262.131h0c.262.262.394.262.525.394.131-.131.131,0,.262,0,.262.787.262,1.05.394,1.181s.131,0,.262,0c-.131.131.131.262,0,.131.131.131.262.394.525.525v0h0c.394.262.131.919.394,1.181h0l.262.262c0,.131-.131,0-.131,0,.262.262.131.525.262.787-.131.131-.131.262,0,.525v.525h.131c.131.131,0,.131,0,.131s0-.131.131,0a11.289,11.289,0,0,1-.131,2.1c0,.262.394.131.262.525l-.131-.131a1.665,1.665,0,0,1,.131.787Z",
    transform: "translate(1.645 0.111)",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_533",
    "data-name": "Ellipse 533",
    cx: 3.543,
    cy: 3.543,
    r: 3.543,
    transform: "translate(12.263 21.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21592",
    "data-name": "Path 21592",
    d: "M16.783,20.062c0-.131-.131-.131,0-.262h0v0c0-.131-.131,0-.131-.131v-.131h0s-.131-.131,0-.131h.131c-.131,0,0-.131-.131-.262h0c0-.131-.131,0-.131-.131h0c0-.131-.131-.262-.131-.394.131,0,0,.131.131,0-.131-.131-.262-.262-.262-.394h0c-.131,0,0-.131-.131-.131h0c0-.131-.131-.131-.262-.262h0c0-.131-.131-.131-.131-.262H15.6c0-.262-.394-.262-.394-.525h0l-.131-.131v.131h-.131c.131,0,0-.131,0-.131h0c0-.131-.131.131-.131,0h-.131c0-.131,0,0,.131,0h0v-.131h0l-.131-.131h0c-.131.131-.131-.131-.262,0,.131,0,0,0,.131-.131v-.131c-.131,0,0-.131-.131,0v-.131c-.131,0,0,0,0,.131-.131,0-.262-.131-.394-.131s-.131.131-.262.131h0v-.131h-.131v-.131s0,.131-.131,0a.129.129,0,0,1,.131-.131H13.5l.131-.131c-.131,0-.131,0-.262.131h0v-.131H13.5c0,.131.131,0,.262,0v.131h-.656v-.131h0v-.131h0a.129.129,0,0,0-.131-.131l-.394.525h-.131v0s0-.131-.131,0v-.131a.129.129,0,0,0-.131.131h-.131a.129.129,0,0,1-.131.131c0-.131-.131,0-.131-.131,0,.131-.262.131-.262.262H11.4c0,.131,0,.131-.131.262-.131,0,0-.131-.131-.262,0,.131-.131.131,0,.131-.131,0,0,0-.131-.131v.131c-.131,0-.131-.131-.131,0v-.131c-.131,0,0,.131,0,.131-.131.131-.131,0-.131,0a.129.129,0,0,1-.131.131h0c0,.131-.131.131-.131.262h0a.129.129,0,0,1,.131.131s0,.131-.131,0h0c-.131,0,0,0,0-.131a.458.458,0,0,1-.131.262c-.131,0,.131-.131,0-.131h.131c-.131,0,0,0-.131-.131l-.262.262.131.131c0,.262-.262,0-.262.131s.131.131,0,.131v-.131c-.131.131.131.131-.131.262v-.131c-.131,0,0,.131,0,.131H9.7c0,.131-.131.262-.131.394H9.434c-.262.262-.262.525-.394.656v.131h0v.525h0c0,.131.131.131,0,.262h0a.983.983,0,0,1-.131.656c.131,0,0,.262.131.262,0,.131-.131.131-.131.262a.129.129,0,0,1,.131.131h0l-.131.131h0v.262l.131.131H8.909c.131.131-.131,0,0,.131h0c0,.131,0,.131.131.262h0c.131.131.131.262.262.394a.129.129,0,0,1,.131-.131h.131a.129.129,0,0,1-.131.131h0a.129.129,0,0,0,.131.131h0c.131.131.131.262.262.262h.131a.282.282,0,0,0,.262.262h.131s.131.131,0,.131a.482.482,0,0,0,.394.131v0h0c.262,0,.394.394.525.394h.262c.131,0,0,0,0,.131.262,0,.262.131.525.131.131.262.394.131.656.131h.131v-.131h1.181c.131,0,0-.262.262-.131v.131l.787-.394h0a.129.129,0,0,0,.131-.131h.131a.129.129,0,0,0,.131-.131h0l.131-.131c.131,0,.131-.131.262-.131A.129.129,0,0,1,16,22.818c.131.131.262,0,.262-.131h.131s.131-.131,0-.131c.262,0,.131-.262.262-.262.131-.262.131-.394.262-.656.131,0-.131.131,0,.262a.789.789,0,0,1,.131-.525v.131c0-.131.131-.394.131-.525h0v-.131h0a.129.129,0,0,1-.131-.131c.131.131.131-.131.262,0h.131c0-.131-.131-.131,0-.131h0a.182.182,0,0,1,0-.262h0c-.656.131-.787,0-.656-.262,0,.131-.131,0,0,0ZM9.959,21.374Zm.131.131Zm2.756,1.837h0V23.08h0a.129.129,0,0,0-.131-.131l-.131.131h-.131v-.131l-.131.131v0H12.19c0-.131-.131,0-.131-.131a.129.129,0,0,0-.131.131c.131-.131-.131,0-.131-.131-.131.131-.131,0-.262,0h0v-.131a.129.129,0,0,1-.131.131.129.129,0,0,1,.131-.131c0,.131-.131,0-.131.131v-.131c-.131.131,0,0-.131,0v-.131H11.4a.129.129,0,0,0-.131.131c-.131,0,0-.131,0-.131H11.14c-.131,0-.131-.131-.262,0h0a.129.129,0,0,1-.131.131h0c0-.131,0,0,.131,0-.131,0-.131,0-.262-.131,0-.131.131,0,.131,0v.131c0-.131,0,0,.131-.131,0-.131-.131,0-.131-.131l-.131.131c-.131,0,.131-.262-.131-.262,0,0-.131.131-.131,0h.131c0-.131-.131,0-.131-.131h.131c0-.131-.131,0-.131,0h.131c0-.131-.131-.131-.262-.262h.131a.482.482,0,0,1-.131-.394H9.959c-.131-.131-.262-.262-.131-.394h0a.129.129,0,0,0-.131-.131h0a.789.789,0,0,1,.131-.525c-.131,0,0-.131-.131-.262.131-.131.131,0,.131-.131L9.7,20.062h.131L9.7,19.931h.131a.129.129,0,0,1,.131-.131v0c0-.131.131,0,0-.131h0l.131-.131h0c0-.131.131-.262.131-.394a.129.129,0,0,1-.131-.131h.131a.129.129,0,0,0,.131-.131h0c.131-.131.131-.131.131-.262v-.131c.131,0,.131-.131.262-.131v-.131h.131l.262-.262h.131c.131-.131.394,0,.525-.131h0l.131-.131v.131c.131-.131.262,0,.262-.131.131.131.262-.131.525,0h0v-.131a1.665,1.665,0,0,1,.787.131c.131,0,.131-.262.262-.131V17.7c.262,0,.394.131.656.131h0c0,.131.131.131.131,0v.131h.131s.131.131.131,0c0,.131.131,0,.131.131.131,0,.131.131.131,0-.131.131,0,.131.131.131v.131h.131c0,.131.262.131.131.262l.394.394c-.131,0-.131-.131-.262-.131.131.131.262.131.262.262h-.131a.482.482,0,0,1,.131.394h.262c-.131,0,0,.131-.262.131h0c0,.131.131,0,.131.131h-.131a.129.129,0,0,1,.131.131h0c0,.131.131.131.131.394H16v.131h0v.131h0v.131h0c0,.131.131,0,.131.131L16,20.981h0v.131h-.131c.131,0,0,.131.131.262h-.262c0,.131.131,0,0,.131h0c0,.131,0,.262-.131.262s0-.131-.131-.131a.482.482,0,0,1-.131.394h0c.131.131-.131,0-.131.131h0c-.131.131,0,.131-.131.262h0l-.131.131v.131c-.262,0-.131.394-.394.394h0l-.131.131h.131v.131c0-.131,0-.131-.131-.131h0c-.131,0,0,.131,0,.131h0v0a.129.129,0,0,1-.131.131v-.131h-.262c0,.131-.131.131-.131.262v-.131h-.131c0,.131-.131,0-.131.131h0c0,.131-.262,0-.262.131-.131.131-.131.131-.131.262h0v-.131h-.131a.129.129,0,0,1-.131.131v-.131L12.846,24v-.131a.129.129,0,0,0-.131.131h.131c0,.131.131,0,.262,0v.131c.131-.787-.131-.787-.262-.787Zm.656-.131Zm.394,0Zm1.312-.919Zm.262-4.856Zm-1.444-.919Zm-.394-.131Zm-4.2,1.837Zm-.131.131Z",
    transform: "translate(2.829 4.873)",
    fill: "#2d82f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19298",
    "data-name": "Group 19298",
    transform: "translate(0.825 35.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21593",
    "data-name": "Path 21593",
    d: "M1.575.108h0c-.131,0,0,.131,0,0a.129.129,0,0,1-.131.131c-.131,0,0,0,.131-.131A2.217,2.217,0,0,1,.919.37,1.016,1.016,0,0,1,.525.239H.131C.131.37,0,.37,0,.5S.131.895.262.895h1.05c-.131-.131.131,0,.131-.131H2.1c.394,0,.262.131.656,0H2.625A2.562,2.562,0,0,0,3.543.633h0a4.375,4.375,0,0,1,1.312,0h.525A2.89,2.89,0,0,0,6.43.5a2.977,2.977,0,0,0,.525.131h0A4.046,4.046,0,0,0,8.268.5c.262.131,1.05,0,1.444.131h.919V.5a5.22,5.22,0,0,0,1.444,0h1.05c.262,0,.262-.131.525-.131h4.331s.262,0,0,.131c.262,0,.394-.131.656-.131h.656s.131,0,0-.131h.131a.482.482,0,0,1,.394.131h1.706c.656.131,1.05-.131,1.706,0h2.887a2.144,2.144,0,0,0,.919,0h.919c.262,0,0,.131.394.131A1.322,1.322,0,0,0,28.74.37h0A.282.282,0,0,0,29,.108a.282.282,0,0,0-.262-.262H26.247l-.131-.131h-.656c0-.131-.262,0-.394,0h0c-.131.131-.394,0-.525,0H22.047a.129.129,0,0,1,.131.131H17.717V-.286M13.78.108h0c-.131.131-.262,0-.394,0h-.131c-.131,0,0,0-.131.131H8.268M19.029.895ZM14.042.239ZM7.48.239Zm9.055,0Zm.262,0h-.656c-.394,0-.394-.131-.525-.131h0a.406.406,0,0,0-.262.131h-.525m-8.137,0H4.856C4.462.239,4.462.108,4.2.108h.131a.789.789,0,0,0-.525.131H2.625m4.2-.131h0ZM20.079.37ZM6.824.108ZM8.4.239H1.312",
    transform: "translate(0 0.344)",
    fill: "#202020"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21594",
    "data-name": "Path 21594",
    d: "M37.425,15.336h0c.131,0,.262,0,.262-.131s0-.131.131-.131h.131q.2,0,.394-.394c.131,0,0-.131.131,0,.262,0,.394,0,.525-.262h0c.131,0,.131,0,.131.131.131.131.131,0,.131,0v-.394h.131l.131-.131v-.131h.131v-.131h.131v-.131a.129.129,0,0,0,.131-.131h0c.131,0,.131,0,.131-.131s.131,0,.131,0l.262-.131c.131,0,0-.131,0-.131h0v-.131h.131a.129.129,0,0,1,.131-.131.129.129,0,0,1,.131-.131.479.479,0,0,0,.262-.656.129.129,0,0,0-.131-.131c-.131-.131-.262-.131-.525,0v.131h0c-.131-.131-.131-.262-.262-.131l-.131.262c-.131,0,0,.131-.131.131s-.131-.131-.262.131a.458.458,0,0,1-.131.262L39,12.973h-.131c-.131,0,0,.131-.262,0h0V13.1h-.131v.131s0,.131-.131,0V13.5h-.262v.131c0-.131-.131-.131-.262,0-.131,0-.131.131,0,.262,0,.131,0,.131.131.262h0l-.131-.131v.131h-.262v.131h0s-.131-.131-.131.131c-.131,0,0,.131-.131,0s-.131,0-.131.131-.131.131-.131.262c0,0-.131,0,0,.131-.131,0,0,0,0,.131s0,0-.131,0h0v.262a.129.129,0,0,0,.131.131c.131-.394.131-.262.394-.131Z",
    transform: "translate(11.525 3.693)",
    fill: "#8adaf4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21595",
    "data-name": "Path 21595",
    d: "M37.994,17.446h0c.131.131.131,0,.262,0h.525c.131,0,.262-.131.394,0h0a.129.129,0,0,1,.131-.131h.525s0-.131.131,0h0l.131-.131h.262l.131-.262h0v.131h.262a.983.983,0,0,0,.656-.131.789.789,0,0,0,.525-.131A.618.618,0,0,0,42.062,16a.479.479,0,0,0-.656-.262c-.131,0-.131.131-.262-.131h0a.129.129,0,0,0-.131.131h0l-.262-.131c-.131,0-.262.131-.394,0-.131.131-.131.131-.131.262h0a.458.458,0,0,0-.131-.262h-.131c0-.131,0,.131-.131,0h0v.131h-.656s-.131.131-.131,0h-.131c0-.131-.131-.131-.131,0v.131h-.262c-.131,0-.131,0-.131-.131h-.131c-.131,0-.262.131-.394.131s-.131.131-.131.262v.131l.131.131a.129.129,0,0,1,.131.131h-.262s.131,0,0,.131c-.131,0-.131.131-.131.262a.282.282,0,0,0,.262.262C37.731,17.578,37.862,17.709,37.994,17.446Z",
    transform: "translate(11.744 4.864)",
    fill: "#8adaf4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21596",
    "data-name": "Path 21596",
    d: "M35.508,13.9c.131,0,.131,0,.262-.131h0s.131,0,0-.131,0,0,.131,0,0,0,0-.131v-.131h.131a.482.482,0,0,0,.131-.394c.131,0,0-.131.131-.131.131-.131.131-.131.131-.262h0l.131-.131h.131v-.131a.129.129,0,0,0-.131-.131v-.131h.131v-.131s-.131-.131,0-.131h.131s.131,0,0-.131,0,0,0-.131.131-.131.131-.262h0s.131-.131,0-.131h0c-.131,0,0,0,.131-.131s-.131-.131,0-.131h0V10.75s.131,0,0-.131v-.262A.479.479,0,0,0,36.82,9.7h-.131a.482.482,0,0,0-.394.131v.131h0l-.262-.131s0,.262-.131.262c.131.131,0,.131,0,.131a.129.129,0,0,0-.131.131v.262l-.131.525h0a.129.129,0,0,1-.131.131h0v.131h0v.262h0s.131.131,0,.131h-.131a.129.129,0,0,1-.131.131h0v.131c.131.131.131.131.262.131h-.131v.131s-.131,0,0,.131h-.131v.131h-.131v.131c-.131,0,0,.131,0,.131s-.131,0,0,.131v.262s-.131.131,0,.131c-.131,0,0,0,0,.131h0l.131.131.131.131c0,.131.131,0,.131.131S35.376,13.9,35.508,13.9Zm.919-1.837Z",
    transform: "translate(10.949 3.03)",
    fill: "#8adaf4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.5730943d1a010b2910baf250145b9777.svg";
export { ForwardRef as ReactComponent };